/*!
 * Manera Popup
 * 
 */
$(document).ready(function(){
    var popupController = new ScrollMagic.Controller();

    //lien close popup
    var close = $('.popup').find('.popup_close');
    // fitting link popup sizechart
    var sizechart = $('.popup').find('.fitting_link');

    if(close.length > 0) {
        var closeOffset = close.offset().top;
        //var vh = $('.popup').innerHeight / 2;
        var vh = window.innerHeight;

        var offset = vh - closeOffset + 1;

        //nav popup adventure
        var nav = $('.popup').find('.subnav');


        var popupCloseScene = new ScrollMagic.Scene({
            triggerElement: close,
            triggerHook: 0.052//'onLeave',
            //offset: '25px',
        });
    }

    if(typeof nav !== "undefined")
    {
        var navScene = new ScrollMagic.Scene({
            triggerElement: nav,
            triggerHook: 0.38,
            //offset: "80px"
        });
    }
    //typeof sizechart !== "undefined"
    if(sizechart.length > 0)
    {
        var linkOffset = sizechart.offset().top;
        var vh = $('.popup').innerHeight / 2;
        var offset = vh - linkOffset + 1;

        /*var sizeChartScene = new ScrollMagic.Scene({
            triggerElement: sizechart,
            offset: offset + "px"
        });*/
    }

    var popuplink = $('.open_popup');

    popuplink.on('click',function(e){
        e.preventDefault();
        $('body').addClass('fixed');
        $('.popup, .overlay').addClass('active');

        popupCloseScene.setPin(close).addTo(popupController);
        if(typeof(navScene) !== "undefined")
        {
            navScene.setPin(nav).addTo(popupController);
        }

       /* if(typeof(sizeChartScene) !== "undefined")
        {
            sizeChartScene.setPin(sizechart).addTo(popupController);
        }*/
    })

    $('.popup .popup_close, .overlay').on('click',function(e){
        e.preventDefault();
        popupCloseScene.removePin(true);
        if(typeof(navScene) !== "undefined")
            navScene.removePin(true);
        /*if(typeof(sizeChartScene) !== "undefined")
            sizeChartScene.removePin(true);*/

        $('.popup, .overlay').removeClass('active');
        $('body').removeClass('fixed');
    })
});